import { render, staticRenderFns } from "./EmailDomainDialog.vue?vue&type=template&id=1b3afe12"
import script from "./EmailDomainDialog.vue?vue&type=script&lang=js"
export * from "./EmailDomainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports